module.exports = __webpack_public_path__ + "media/images/leevo-cover-c89233478a89852eaeef22159da8c68a.jpg";